export const GTP_BET_BUILDER_COMBINATION_TYPE = 'gtp_betbuilder';

export const GTP_BET_BUILDER_BASE_CLASS = 'gtp-betbuilder';
export const GTP_BET_BUILDER_HEADER_CLASS = `${GTP_BET_BUILDER_BASE_CLASS}-header`;
export const GTP_BET_BUILDER_HEADER_DETAILS_CLASS = `${GTP_BET_BUILDER_HEADER_CLASS}-details`;
export const GTP_BET_BUILDER_BODY_CLASS = `${GTP_BET_BUILDER_BASE_CLASS}-body`;
export const GTP_BET_BUILDER_SELECTION_CLASS = `${GTP_BET_BUILDER_BODY_CLASS}-selection`;
export const GTP_BET_BUILDER_SELECTION_STATUS_INDICATOR_CLASS = `${GTP_BET_BUILDER_SELECTION_CLASS}-status-indicator`;
export const GTP_BET_BUILDER_SELECTION_STATUS_INDICATOR_WRAPPER_CLASS = `${GTP_BET_BUILDER_SELECTION_STATUS_INDICATOR_CLASS}-wrapper`;

export const BET_BUILDER_I18N_KEY = 'betbuilder.betbuilder';
export const BET_BUILDER_PLUS_I18N_KEY = 'betbuilder.betbuilder+';
export const BET_BUILDER_ABBR_I18N_KEY = 'betbuilder.icon-text';
export const BET_BUILDER_PLUS_ABBR_I18N_KEY = 'betbuilder.icon-text+';

export const GTP_BET_BUILDER_ONBOARDING_TYPE = 'gtp_betbuilder';
export const GTP_BET_BUILDER_ONBOARDING_TITLE_I18N_KEY = 'instruction_cards.betbuilder_title';
export const GTP_BET_BUILDER_ONBOARDING_CONTENT_I18N_KEY = 'instruction_cards.betbuilder_content';
